import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { useInView } from 'react-intersection-observer';
import { motion } from 'framer-motion';
import { graphql, Link, useStaticQuery } from 'gatsby';
import { media } from '../../utils/media-queries';
import { LayoutContext } from '../organisms/layoutProvider';

const Footer = () => {
  const { contact, disclaimer, privacy } = useStaticQuery(graphql`
    query Footer {
      contact: allSanityContact {
        nodes {
          instagram
          mail
        }
      }
      privacy: allSanityPrivacy {
        nodes {
          title {
            de
            en
          }
        }
      }
      disclaimer: allSanityDisclaimer {
        nodes {
          title {
            de
            en
          }
        }
      }
    }
  `);

  const { language } = useContext(LayoutContext);

  const [year, setYear] = useState();
  useEffect(() => {
    setYear(new Date().getFullYear());
  }, []);

  const { ref, inView } = useInView({});

  return (
    <StyledFooter
      ref={ref}
      initial={{ filter: 'blur(10px)' }}
      animate={{ filter: inView ? 'blur(0px)' : 'blur(10px)' }}
      transition={{ duration: 0.9 }}
    >
      <div className="copyright">©</div>
      <div className="left">
        <div className="copy-small">
          CLAUDIA <br />
          SIX <br />
          {year}
        </div>
      </div>
      <div className="right copy-small">
        <Link
          className="hover"
          to={language === 'en' ? '/disclaimer' : '/de/disclaimer'}
          style={{ display: 'block' }}
        >
          {disclaimer.nodes[0].title[language]} <br />
        </Link>
        <Link
          className="hover"
          to={language === 'en' ? '/privacy' : '/de/privacy'}
          style={{ display: 'block' }}
        >
          {privacy.nodes[0].title[language]} <br />
        </Link>
        <a
          href="https://claudiasix.substack.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="hover"
        >
          SUBSTACK
        </a>{' '}
        –{' '}
        <a
          href={contact.nodes[0].instagram}
          target="_blank"
          rel="noopener noreferrer"
          className="hover"
        >
          INSTAGRAM
        </a>{' '}
        –{' '}
        <a
          href={`mailto:${contact.nodes[0].mail}`}
          target="_blank"
          rel="noopener noreferrer"
          className="hover"
        >
          MAIL ME
        </a>
        <br />
      </div>
    </StyledFooter>
  );
};

const StyledFooter = styled(motion.footer)`
  background: var(--text-color);
  color: var(--bg-color);
  font-family: var(--font-1);
  position: relative;
  padding: var(--v-spacing-S);

  .copyright {
    font-family: var(--font-2);
    font-size: var(--spacing-XS);
    padding-top: var(--spacing-XS);
    position: absolute;
  }

  .left {
    padding-top: var(--spacing-XS);
    display: flex;
  }

  .left,
  .right {
    padding-left: var(--spacing-XS);
    padding-bottom: var(--spacing-XS);
    text-transform: uppercase;
  }

  .right {
    a {
      padding-bottom: var(--spacing-XXS);
    }
  }

  @media ${media.M} {
    display: flex;
    padding: var(--spacing-L) var(--v-spacing-S);

    .copyright {
      padding-top: var(--spacing-XXS);
    }

    .left,
    .right {
      padding: 0;
      width: 50%;
    }

    .left {
      padding-left: var(--spacing-XS);
    }

    .right {
      a {
        padding-bottom: 0;
      }
    }
  }
`;

export default Footer;
